import React from "react";
import { useGetCrmDashboard } from "../../hooks/useCrm";
import DashboardApp from "../DashboardApp/DashboardApp";
import { CrmDashboardWrapper } from "./DashboardCrmStyle";
import People from "../../assets/images/people.svg";
import onlineSell from "../../assets/images/onlineSell.svg";
import currentSell from "../../assets/images/currentSell.svg";
import failedSell from "../../assets/images/failedSell.svg";
import customers from "../../assets/images/customers.svg";
import clue from "../../assets/images/clue.svg";
import vipCustomer from "../../assets/images/vipCustomer.svg";
import todayUser from "../../assets/images/todayUser.svg";
import action from "../../assets/images/action.svg";
import passedAction from "../../assets/images/passedAction.svg";
import actionDone from "../../assets/images/actionDone.svg";

export const DashboardCrm = () => {
  const { data } = useGetCrmDashboard();

  return (
    <CrmDashboardWrapper>
      <DashboardApp
        crmData={data?.data}
        row1_1IconCrm={
          <img
            style={{ margin: "0 auto" }}
            src={People}
            className="img-fluid"
          />
        }
        row1_2IconCrm={
          <img
            style={{ margin: "0 auto" }}
            src={onlineSell}
            className="img-fluid"
          />
        }
        row1_3IconCrm={
          <img
            style={{ margin: "0 auto" }}
            src={currentSell}
            className="img-fluid"
          />
        }
        row1_4IconCrm={
          <img
            style={{ margin: "0 auto" }}
            src={failedSell}
            className="img-fluid"
          />
        }
        row2_1IconCrm={
          <img
            style={{ margin: "0 auto" }}
            src={customers}
            className="img-fluid"
          />
        }
        row2_2IconCrm={
          <img style={{ margin: "0 auto" }} src={clue} className="img-fluid" />
        }
        row2_3IconCrm={
          <img
            style={{ margin: "0 auto" }}
            src={vipCustomer}
            className="img-fluid"
          />
        }
        row2_4IconCrm={
          <img
            style={{ margin: "0 auto" }}
            src={todayUser}
            className="img-fluid"
          />
        }
        row3_1IconCrm={
          <img
            style={{ margin: "0 auto" }}
            src={action}
            className="img-fluid"
          />
        }
        row3_2IconCrm={
          <img
            style={{ margin: "0 auto" }}
            src={passedAction}
            className="img-fluid"
          />
        }
        row3_3IconCrm={
          <img
            style={{ margin: "0 auto" }}
            src={actionDone}
            className="img-fluid"
          />
        }
        pathName1_1="reporting/tradinglist"
        pathName1_2="reporting/tradinglist"
        pathName1_3="reporting/tradinglist"
        pathName1_4="reporting/tradinglist"
        pathName2_1="advancedsearch"
        pathName2_2="advancedsearch"
        pathName2_3="advancedsearch"
        pathName2_4="reporting/firstfiles"
        pathName3_1="reporting/todayactivities"
        pathName3_2="reporting/passedActivities"
        pathName3_3="reporting/activitiesdonetoday"
        pathName3_4
      />
    </CrmDashboardWrapper>
  );
};
